<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">签收说明</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">签收说明</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p class="font16">
                            <strong style="color: rgb(229, 51, 51);">一、验货说明</strong>
                        </p>
                        <p>
                            请您收到商品后务必先对商品的外包装进行检查，包裹与夜樱情趣商城包裹展示样式相同，且外包装完好无损，您可以放心签收。
                        </p>
                        <p><br></p>
                        <p class="font16">
                            <strong style="color: rgb(229, 51, 51);">二、签收说明</strong>
                        </p>
                        <p>
                            夜樱情趣商城为了保障个人隐私，即便您没有当面验收就签收，在您没有使用该产品的情况下发现产品有质量问题，可在签收商品7天内申请退换货服务，夜樱情趣商城会为您做退换货处理。
                        </p>
                        <p><br></p>
                        <p class="font16">
                            <strong style="color: rgb(229, 51, 51);">三、注意事项</strong>
                        </p>
                        <p>
                            您签收后发现商品有任何问题，可直接联系夜樱情趣商城售后服务：在线客服（工作时间：上午9:00-12:00，下午13:30-18:00），我们会在工作时间为您做商品售后处理，在发现问题后请勿使用商品，以便夜樱情趣商城为您核实。
                        </p>
                        <p><br></p>
                    </div>
                    <!--info over-->
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p style="font-size:16px;">
                        <a href="/help/tuihuan" style="float:left;">上一篇:夜樱情趣商城退换货政策</a>
                        <a href="/help/wuliu" class="pl10" style="float:right">下一篇:快递物流说明</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.font16{font-size: 16px;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/qianshou.vue